import { EventsApi } from 'apiLegacy'
import { createLegacyApiInstance } from 'utils'

const apiInstance = () => createLegacyApiInstance(EventsApi)

export const getEventHistory = (eventId?: string) => {
  return apiInstance().getEventHistory(eventId)
}
